import { render, staticRenderFns } from "./AddBill.vue?vue&type=template&id=f8bb8172&scoped=true&"
import script from "./AddBill.vue?vue&type=script&lang=js&"
export * from "./AddBill.vue?vue&type=script&lang=js&"
import style0 from "./AddBill.vue?vue&type=style&index=0&id=f8bb8172&prod&scoped=true&lang=css&"
import style1 from "./AddBill.vue?vue&type=style&index=1&id=f8bb8172&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb8172",
  null
  
)

export default component.exports